import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var PaperPlane = function PaperPlane(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.873 2.1274c-0.12609-0.12652-0.31652-0.16217-0.48-0.091739l-19.13 8.2609c-0.15696 0.067826-0.25913 0.2213-0.26217 0.39217-0.0026087 0.17087 0.095218 0.32739 0.24957 0.40043l5.2644 2.477c0.61305 0.28913 1.3439 0.19261 1.863-0.24522l8.4057-7.103-7.1035 8.4052c-0.43826 0.51826-0.53435 1.2496-0.24565 1.863l2.4774 5.2643c0.072174 0.15261 0.22522 0.24957 0.39348 0.24957h0.0069565c0.17087-0.0026087 0.32435-0.10565 0.39217-0.26217l8.2609-19.13c0.070435-0.16391 0.034348-0.35391-0.091739-0.48"
  })));
};

PaperPlane.displayName = 'PaperPlane';
export default PaperPlane;